import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", { d: "M10.521 7.95h0v2.927c1.21.076 3.737.067 3.737-1.43 0-1.497-2.126-1.497-3.737-1.497z" }),
    _createVNode("path", { d: "M13.425 6.432c1.983.19 3.538.778 3.71 2.528.117 1.276-.438 2.035-1.355 2.463 1.481.359 2.382 1.202 2.196 3.072-.227 2.343-2.035 2.952-4.62 3.08l.004 2.42-1.522.002-.004-2.42c-.389-.005-.819.015-1.25.002l.004 2.42-1.52.001-.004-2.42-3.044-.058.256-1.768s.724.012 1.129.012c.423-.002.549-.293.58-.485l-.008-3.878.012-2.76c-.046-.288-.248-.634-.87-.644.033-.03-1.115.001-1.115.001L6 6.38l3.12-.005-.004-2.37 1.571-.002.004 2.37c.403-.01.8-.003 1.205-.001l-.004-2.37L13.422 4l.003 2.432z" }),
    _createVNode("path", { d: "M10.5 15.637c.991.036 4.506.247 4.49-1.418.016-1.713-3.512-1.483-4.49-1.491v2.909z" })
  ]))
}